export const inCabCamerasAgreement = (name?: string, date?: string) => {
  return [
    { text: 'Driver Agreement on In-Cab Cameras', style: 'h1' },

    { text: "This agreement outlines the policy regarding the use of in-cab cameras in vehicles operated by drivers contracted by Sierra Expediting inc. The purpose of in-cab cameras is to ensure safety, security, and compliance with company policies and regulations.", style: 'p' },

    { text: "Sierra Expediting inc is committed to maintaining a safe and secure environment for both drivers and the public. To support this commitment, in-cab cameras have been installed in all company vehicles. These cameras are intended to monitor driver behavior, ensure compliance with safety protocols, and provide evidence in the event of an incident.", style: 'p' },

    { text: "Driver Responsibilities:", style: 'p', bold: true },

    { text: "1. Camera Visibility", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- Drivers must ensure that in-cab cameras remain unobstructed at all times. Cameras must not be covered, blocked, or tampered with in any way.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "2. Privacy Mode", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- In-cab cameras are designed to switch to a privacy mode when the vehicle is at a complete stop. This privacy mode ensures that the camera does not record or transmit footage while the vehicle is stationary, respecting the driver's privacy during breaks or rest periods.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "3. Compliance", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- Drivers are required to comply with this policy as a condition of their employment with [Company Name]. Failure to comply may result in disciplinary action, up to and including termination of employment.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "4. Reporting Issues", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- If a driver encounters any issues with the in-cab camera system, such as malfunctioning equipment or accidental obstruction, they must report it immediately to their supervisor or the designated company contact.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Penalties for Non-Compliance", style: 'p', bold: true },
 
    { text: "1. Daily Fines", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- Drivers who violate this policy by covering, blocking, or tampering with in-cab cameras will be fined $25 for the first day of non-compliance.", style: 'p', margin: [40, 0, 0, 0] },
    { text: "- For each subsequent day of non-compliance, drivers will be fined $50 per day.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Acknowledgment", style: 'p', bold: true },

    { text: "By signing this agreement, I acknowledge that I have read and understand the policy regarding in-cab cameras. I agree to comply with all requirements outlined in this policy and understand that any violation may result in disciplinary action, including daily fines for non-compliance.", style: 'p' },

    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0,-22, 0, 0]},
    { text: "Driver's Name", style: 'label', margin: [0,5,0,0]},
    { text: "Driver's Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-32, 0, 0]},
    { text: "Date", style: 'label', margin: [340,5,0,0] },

    { text: '', pageBreak: 'before' },
  ];
};